import { render, staticRenderFns } from "./FacebookPixelRegister.vue?vue&type=template&id=1961b3d4&"
import script from "./FacebookPixelRegister.vue?vue&type=script&lang=js&"
export * from "./FacebookPixelRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports